var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var PriceEndpointPushDataProvider = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param client
     */
    function PriceEndpointPushDataProvider(client, endpoint) {
        /**
         * Map of jobs
         */
        this.subscriptions = new Map();
        this.endpoint = endpoint;
        this.client = client;
    }
    /**
     * Observes prices of the notation
     *
     * @param params
     */
    PriceEndpointPushDataProvider.prototype.observe = function (params) {
        var granularity = params.granularity || '1S';
        var quality = params.quality || 'BST';
        var idString = String(params.idNotation);
        if (!this.subscriptions.has(idString)) {
            var observeEndpoint = this.client.observeEndpoint('GET', this.endpoint, {
                quality: quality,
                id: idString,
            }, { minInterval: this.convertGranularityToMs(granularity) });
            this.subscriptions.set(idString, observeEndpoint);
        }
        return this.subscriptions.get(idString);
    };
    /**
     * Unsubscribe from all current field instances and notations
     */
    PriceEndpointPushDataProvider.prototype.dispose = function () {
        return __awaiter(this, void 0, void 0, function () {
            var subscriptionsToClear;
            var _this = this;
            return __generator(this, function (_a) {
                subscriptionsToClear = [];
                this.subscriptions.forEach(function (value, key) {
                    subscriptionsToClear.push(_this.clearByNotation(key));
                });
                this.subscriptions.clear();
                return [2 /*return*/, Promise.all(subscriptionsToClear)];
            });
        });
    };
    /**
     * Unsubscribe from notation
     *
     * @param idNotation
     */
    PriceEndpointPushDataProvider.prototype.clearByNotation = function (idNotation) {
        return __awaiter(this, void 0, void 0, function () {
            var idNotationString, observable;
            return __generator(this, function (_a) {
                idNotationString = String(idNotation);
                if (this.subscriptions.get(idNotationString)) {
                    observable = this.subscriptions.get(idNotationString);
                    if (observable.idJob > 0) {
                        this.subscriptions.delete(idNotationString);
                        return [2 /*return*/, this.clearByJob(observable.idJob)];
                    }
                }
                return [2 /*return*/, null];
            });
        });
    };
    /**
     * Unsubscribe from job
     *
     * @param {number} idJob
     * @returns {Promise<any>}
     */
    PriceEndpointPushDataProvider.prototype.clearByJob = function (idJob) {
        return __awaiter(this, void 0, void 0, function () {
            var idJobNumber;
            return __generator(this, function (_a) {
                idJobNumber = Number(idJob);
                return [2 /*return*/, this.client.unobserveEndpoint(idJobNumber)];
            });
        });
    };
    /**
     * Convert the Subsample Granularity type to milliseconds
     *
     * @param granularity
     * @param defaultMs
     * @returns {number}
     */
    PriceEndpointPushDataProvider.prototype.convertGranularityToMs = function (granularity, defaultMs) {
        if (defaultMs === void 0) { defaultMs = 1000; }
        switch (granularity) {
            case '1S': return 1000;
            case '5S': return 5000;
            default: return defaultMs;
        }
    };
    return PriceEndpointPushDataProvider;
}());
export { PriceEndpointPushDataProvider };
//# sourceMappingURL=PriceEndpointPushDataProvider.js.map